import React, { useState } from "react";
import pic1 from "../Assets/About/new1.jpg";
import pic2 from "../Assets/About/new2.jpg";

const ServiceSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const services = [
    {
      title: "Personalized Growth Strategies",
      content: [
        "We understand that every brand is unique. Our tailored strategies help your business grow online and connect with the right audience meaningfully.",
      ],
    },
    {
      title: "Brand Identity & Storytelling",
      content: [
        "Your brand is more than just a product—it's a story. We craft authentic storytelling that aligns with your values and resonates with your audience.",
      ],
    },
    {
      title: "Building Authentic Connections",
      content: [
        "We believe in the power of genuine relationships. Our content creates real connections between your brand and its followers, fostering loyalty and trust.",
      ],
    },
    {
      title: "Your Success Journey",
      content: [
        "Your success is our success. We're here to cheer you on every step of the way, turning your ideas into something truly special.",
      ],
    },
  ];

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="relative w-full h-auto bg-[#fafafa] p-6 md:p-16 lg:p-32 flex flex-col md:flex-row">
      {/* Services text - horizontal on mobile, vertical on desktop */}
      <div className="md:-mr-32 mb-8 md:mb-0">
        <h1
          className="text-5xl md:text-6xl lg:text-8xl text-[#846050] font-bold md:transform md:-rotate-90 md:translate-y-[360px] md:origin-left tracking-wider text-center md:text-left"
          style={{
            fontFamily: "Blacker Pro Display",
          }}
        >
          YOU GET
        </h1>
      </div>

      {/* Images section - full width on mobile, adjusted for desktop */}
      <div className="relative w-full md:w-1/4 md:mr-20 mb-12 md:mb-0">
        <img
          src={pic1}
          alt="Notes"
          className="w-full h-[300px] md:h-[450px] object-cover rounded-lg shadow-lg"
        />
        <img
          src={pic2}
          alt="Person"
          className="absolute -bottom-10 md:-bottom-20 right-0 md:-right-32 w-2/3 md:w-3/4 h-[200px] md:h-[250px] object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Services list */}
      <div className="flex-1 mt-16 md:mt-0 md:ml-56">
        {services.map((service, index) => (
          <div key={index} className="mb-4">
            <button
              className="w-full flex justify-between items-center py-3 border-t border-gray-200 text-left"
              onClick={() => handleClick(index)}
            >
              <span
                className="text-lg md:text-xl font-medium tracking-wider pr-4"
                style={{
                  fontFamily: "Blacker Pro Display",
                }}
              >
                {service.title}
              </span>
              <span className="text-xl md:text-2xl flex-shrink-0">
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>

            {activeIndex === index && (
              <div className="py-3 pl-4 text-gray-600 space-y-2">
                {service.content.map((item, i) => (
                  <p key={i} className="text-xs md:text-sm">
                    {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}

        <button className="w-full md:w-auto mt-8 px-8 py-3 border-2 border-[#724539] text-[#724539] text-sm font-medium hover:bg-[#704735] hover:text-white transition-colors">
          EXPLORE OUR SERVICES
        </button>
      </div>
    </div>
  );
};

export default ServiceSection;
